module.exports = __webpack_public_path__ + "static/media/Fullscreen.6ffd3846.svg";